import React from 'react';
import { Grid, Typography } from '@mui/material';
import { HorizontalLine } from '../../utils/components';

const ActiveFilters = ({ filtrado, filters }) => {
  const hasActiveFilters = filtrado && (
    filters.descricao ||
    filters.nome ||
    filters.dataInicio ||
    filters.dataFim ||
    filters.telefone ||
    filters.status
  );

  if (!hasActiveFilters) return null;

  const buildFilterText = () => {
    const filterParts = [];

    if (filters.descricao) {
      filterParts.push("Descrição: " + filters.descricao);
    }
    if (filters.nome) {
      filterParts.push("Nome: " + filters.nome);
    }
    if (filters.dataInicio) {
      filterParts.push("Data inicio: " + filters.dataInicio);
    }
    if (filters.dataFim) {
      filterParts.push("Data fim: " + filters.dataFim);
    }
    if (filters.telefone) {
      filterParts.push("Telefone: " + filters.telefone);
    }

    return filterParts.join(", ");
  };

  return (
    <>
      <Grid item xs={12}>
        <HorizontalLine />
      </Grid>
      <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
        <Typography>{buildFilterText()}</Typography>
      </Grid>
      <Grid item xs={12}>
        <HorizontalLine />
      </Grid>
    </>
  );
};

export default ActiveFilters;
